import Enumerator from '../global/Enumerator';

export const filterTypes = ['ticket', 'contact', 'job'];

export class FilterType extends Enumerator {
  static default() {
    return this.of('ticket');
  }
}
FilterType.initEnum({
  contact: {
    get title() {
      return 'Contact';
    },
    get weight() {
      return 2;
    }
  },
  job: {
    get title() {
      return 'Task';
    },
    get weight() {
      return 3;
    }
  },
  ticket: {
    get title() {
      return 'Deal';
    },
    get weight() {
      return 1;
    }
  }
});

export default {
  filterTypes,
  FilterType
};
